import * as React from 'react';
import { HeadFC, PageProps } from 'gatsby';
import Layout from '../layout';
import Banner from './components/banner';
import Technical from './components/technical';
import Bridge from './components/bridge';
import Ecological from './components/ecological';
import Network from './components/network';
import Governance from './components/governance';
import Helping from './components/helping';
import Benefits from './components/benefits';
import Swiper from './components/swiper';
import Entry from './components/entry';
import Features from './components/features';
import WhatIsMtt from './components/whatIsMtt';
import PieEchart from './components/pieEchart';
import AreaEchart from './components/areaEchart';
import { useRef } from 'react';
import { Parallax, ParallaxLayer, IParallax } from '@react-spring/parallax';

import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { useGSAP } from '@gsap/react';
import './index.scss';
import DataArea from './components/dataArea';
import useIsMobile from '../hooks/useIsMobile';

const IndexPage: React.FC<PageProps> = () => {
  const isMobile = useIsMobile();
  const main = useRef(null);
  var smoother = useRef();

  const parallax = useRef<IParallax>(null!);

  useGSAP(
    () => {
      // create the smooth scroller FIRST!

      ScrollTrigger.create({
        trigger: '.box-1',
        pin: true,
        start: 'center center',
        end: '+=1000',
        // markers: true,
      });
      ScrollTrigger.create({
        trigger: '.box-2',
        pin: true,
        start: 'center center',
        end: '+=1000',
        // markers: true,
      });
    },
    { scope: main }
  );

  return (
    <Layout title="MTT Network">
      <Banner />
      <DataArea />
      <Features />
      <WhatIsMtt />
      {!isMobile && (
        <div style={{ width: '100%', height: '1200px', position: 'relative' }}>
          <Parallax ref={parallax} pages={1.4} className="index-parallax">
            <ParallaxLayer
              sticky={{ start: 0, end: 1 }}
              style={{ backgroundColor: '#020722', zIndex: 1 }}
            >
              <PieEchart />
            </ParallaxLayer>

            <ParallaxLayer
              translate="yes"
              offset={0.9}
              speed={1}
              style={{ zIndex: 99 }} // 确保 zIndex 高于第一个组件
            >
              <AreaEchart />
            </ParallaxLayer>
          </Parallax>
        </div>
      )}
      {isMobile && (
        <>
          <PieEchart />
          <AreaEchart />
        </>
      )}

      {/* <Technical />
      <Bridge />
      <Ecological /> */}

      <Network />

      <Governance />

      {/* <Helping /> */}

      <Benefits />

      <Swiper />

      <Entry />
    </Layout>
  );
};

export default IndexPage;
